import gql from 'graphql-tag';
import {
	CommentFragment,
	PageInfoFragment,
} from '@app/pages/cmms/graphql/cmms-fragments';
import { SimpleLabelFragment } from '@app/pages/settings/graphql/labels.queries';

export const FileFragment = gql`
	fragment FileFragment on FileEntityType {
		fileEntityId
		version
		notes
		assets {
			name
			id
			pk
			location {
				name
				type
			}
		}
		createdBy {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
		}
		name
		pk
		created
		updated
		file {
			contentType
			isProcessed
			name
			url
		}
		workOrders {
			workOrderId
			name
			status
			priority
			pk
		}
		incidents {
			incidentId
			priority
			id
			pk
			name
			status
		}
		requests {
			requestId
			priority
			id
			pk
			name
			status
		}
		classificationsV2 {
			name
			pk
			type
		}
		locations {
			id
			locationId
			locationType
			name
			pk
		}
		comments {
			...CommentFragment
		}
		type
		labels {
			...SimpleLabelFragment
		}
	}
	${CommentFragment}
	${SimpleLabelFragment}
`;

export const FilesQuery = gql`
	query FilesQuery(
		$first: Int
		$last: Int
		$after: String
		$before: String
		$search: String
		$locations: [UUID]
		$classifications: [String]
		$assetTypeId: String
		$type: [String]
		$labels: [ID]
		$updatedAfter: DateTime
		$updatedBefore: DateTime
		$hidePopulatedLocations: Boolean
		$hidePopulatedClassifications: String
		$hidePopulatedType: Boolean
		$hidePopulatedAssets: Boolean
		$hidePopulatedWorkOrders: Boolean
		$hidePopulatedIncidents: Boolean
		$hidePopulatedRequests: Boolean
	) {
		files(
			first: $first
			after: $after
			before: $before
			last: $last
			search: $search
			locations: $locations
			classifications: $classifications
			assetTypeId_In: $assetTypeId
			type: $type
			labels_Id_In: $labels
			updatedAfter: $updatedAfter
			updatedBefore: $updatedBefore
			hidePopulatedLocations: $hidePopulatedLocations
			hidePopulatedClassifications: $hidePopulatedClassifications
			hidePopulatedType: $hidePopulatedType
			hidePopulatedAssets: $hidePopulatedAssets
			hidePopulatedWorkOrders: $hidePopulatedWorkOrders
			hidePopulatedIncidents: $hidePopulatedIncidents
			hidePopulatedRequests: $hidePopulatedRequests
		) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...FileFragment
				}
			}
			totalCount
		}
	}
	${FileFragment}
	${PageInfoFragment}
`;

export const FilesSearchQuery = gql`
	query FilesSearchQuery($search: String) {
		files(search: $search) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...FileFragment
				}
			}
			totalCount
		}
	}
	${FileFragment}
	${PageInfoFragment}
`;

export const ClassificationCategoriesQuery = gql`
	query ClassificationCategoriesQuery($name: String, $type: ClassificationTypes) {
		classifications(name: $name, type: $type) {
			edges {
				node {
					name
					type
					pk
				}
			}
		}
	}
`;

export const FileEntityQuery = gql`
	query FileEntityQuery($pk: UUID!) {
		file(pk: $pk) {
			...FileFragment
		}
	}
	${FileFragment}
`;

export const aiClassificationJob = gql`
	query AiClassificationJob($pk: UUID!) {
		aiClassificationJob(pk: $pk) {
			total
			processed
			status
			pk
		}
	}
`;
